/**
 * Admin Auth Store
 * Zustand store for admin UI authentication state
 * Persists admin token to localStorage
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminAuthStore {
  adminToken: string | null;
  emailVerified: boolean;
  setAdminToken: (token: string) => void;
  setEmailVerified: (verified: boolean) => void;
  clear: () => void;
}

export const useAdminAuthStore = create<AdminAuthStore>()(
  persist(
    (set) => ({
      adminToken: null,
      emailVerified: false,

      setAdminToken: (token: string) => {
        set({ adminToken: token });
      },

      setEmailVerified: (verified: boolean) => {
        set({ emailVerified: verified });
      },

      clear: () => {
        set({ adminToken: null, emailVerified: false });
      },
    }),
    {
      name: 'tilly_admin_auth',
      partialize: (state) => ({
        adminToken: state.adminToken, // Persist token
        // emailVerified is NOT persisted — must be re-verified on each session
      }),
    }
  )
);
